<template>
  <div class="devbox" v-if="active">
    <h4>
      Devbox (BeMob v2)
      <a class="close" @click="active = false"> close [x] </a>
    </h4>
    <div>
      <a>Alert</a> | <a>Clear</a>
      <hr />
      QUERY:
      <hr />
      <pre v-html="query"></pre>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import QC from '@/components/query/query-constructor';

const route = useRoute();
const active = ref(false);
const query = ref('');

const syntaxHighlight = (json: string) => {
  let formatted = json;
  if (typeof formatted !== 'string') {
    formatted = JSON.stringify(formatted, undefined, 2);
  }
  formatted = formatted.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  return formatted.replace(
    /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
    (match) => {
      let className = 'number';
      if (/^"/.test(match)) {
        className = /:$/.test(match) ? 'key' : 'string';
      } else if (/true|false/.test(match)) {
        className = 'boolean';
      } else if (/null/.test(match)) {
        className = 'null';
      }
      return `<span class="${className}">${match}</span>`;
    },
  );
};

const updateQuery = (data: unknown) => {
  query.value = syntaxHighlight(JSON.stringify(QC.decode(data), null, 2));
};

const onKeyUp = (event: KeyboardEvent) => {
  if (event.key === 'p' && event.altKey) {
    active.value = !active.value;
  }
};

watch(
  () => route.params.data,
  (data) => {
    updateQuery(data);
  },
);

onMounted(() => {
  window.addEventListener('keyup', onKeyUp);
  updateQuery(route.params.data);
});

onBeforeUnmount(() => {
  window.removeEventListener('keyup', onKeyUp);
});
</script>

<style lang="scss">
.devbox {
  z-index: 1000;
  position: fixed;
  bottom: 0;
  min-height: 200px;
  height: auto;
  background: var(--color-white);
  border-top: 1px solid var(--color-red);
  padding-left: 16px;
  padding-top: 6px;
  padding-right: 16px;
  width: 100%;
  .close {
    float: right;
  }
  h4 {
    border-bottom: 1px solid var(--color-gray5);
    margin-bottom: 6px;
  }
  hr {
    margin-top: 6px;
    margin-bottom: 6px;
  }
  pre {
    outline: 1px solid var(--color-gray20);
    padding: 5px;
    margin: 5px;
    max-height: 400px;
    overflow-y: auto;
  }
  .string {
    color: green;
  }
  .number {
    color: darkorange;
  }
  .boolean {
    color: blue;
  }
  .null {
    color: magenta;
  }
  .key {
    color: red;
  }
}
</style>
